// Facebook app IDs are public client identifiers. Keep one source of truth so
// every sign-in entry point uses the same Meta application.
export const FACEBOOK_APP_ID =
  process.env.REACT_APP_FACEBOOK_APP_ID || "1522913045806222";
